module.exports = __webpack_public_path__ + "img/spark-b.15e435bd.png";